export default {
      id: "common__user-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "img/icons.svg#common__user",
      toString: function () {
        return this.url;
      }
    }